import { KeyType } from '../types';

export const buttonComponentProps: KeyType = {
  primary:
    'tw-bg-blue-800 tw-border tw-border-white tw-text-white hover:tw-bg-blue-600',
  primaryLink:
    'tw-bg-transparent tw-text-blue-800 hover:tw-text-blue-600 tw-px-2',
  error:
    'tw-bg-red-600 tw-border tw-border-white tw-text-white hover:tw-bg-rose-600',
  errorLink:
    'tw-bg-transparent tw-text-rose-800 hover:tw-text-rose-600 tw-py-0 tw-px-2',
  disabled: `tw-bg-[#e1e1e5] tw-border tw-border-neutral-200 tw-text-gray-400`,
  rounded: `tw-rounded-full`
};

export const alertComponentProps: KeyType = {
  primary: 'tw-bg-blue-200 tw-text-blue-500',
  error: 'tw-bg-rose-200 tw-text-red-500',
  success: 'tw-bg-green-300 tw-text-green-700',
  warning: 'tw-bg-yellow-100 tw-text-yellow-500'
};

export const badgeComponentProps: KeyType = {
  primary: 'tw-text-blue-700',
  primaryContainer: 'tw-bg-blue-200',
  error: 'tw-text-rose-700',
  errorContainer: 'tw-bg-rose-200',
  success: 'tw-text-green-700',
  successContainer: 'tw-bg-green-200',
  warning: 'tw-text-yellow-600',
  warningContainer: 'tw-bg-yellow-200'
};

export const checkboxComponentProps: KeyType = {
  primary:
    'checked:tw-border-blue-500 checked:tw-bg-blue-500 checked:before:tw-bg-blue-500 tw-border-blue-500'
};

export const radioComponentProps: KeyType = {
  primary:
    'tw-text-blue-500 checked:tw-border-blue-500 checked:before:tw-bg-blue-500',
  primaryContainer: 'tw-text-blue-500'
};

export const switchComponentProps: KeyType = {
  primaryLabel:
    'peer-checked:tw-border-blue-500 peer-checked:before:tw-bg-pink-500',
  primaryInput:
    'checked:tw-bg-blue-500 peer-checked:tw-border-blue-500 peer-checked:before:tw-bg-blue-500'
};
